import updateCabinetVisualizer from './updateCabinetVisualizer';

export default (set, get, product, designId) => {
  const design = get().cabinetVisualizer.designs[designId];
  set(
    updateCabinetVisualizer(set, get, {
      designs: {
        ...get().cabinetVisualizer.designs,
        [designId]: {
          ...design,
          Products: [
            ...design.Products,
            product
          ]
        }
      }
    }),
    false,
    { type: 'cabinetVisualizer/addCabinetToDesign' }
  );
};